import { cx } from "class-variance-authority";
import { useRouter } from "next/router";
import { JobFilterContainer } from "./container";
import { DepartmentsFilterItem } from "./items/departments-filter-item";
import { EmploymentFilterItem } from "./items/employment-filter-item";
import { OfficeLocationsFilterItem } from "./items/office-locations-filter-item";
import { PositionsFilterItem } from "./items/positions-filter-item";

export const JobFilterUI = (props: { showCloseButtonForMobile?: boolean }) => {
  const router = useRouter();
  const isAgencyApply = router.asPath?.includes("agency");

  return (
    <JobFilterContainer
      className={cx(
        "bg-white",
        "md:p-8",
        "rounded-md",
        "md:border-dublin-gray md:border"
      )}
      showCloseButtonForMobile={props.showCloseButtonForMobile}
      baseUrl={`/app/${router.query.org}${isAgencyApply ? "/agency" : ""}/jobs`}
    >
      <DepartmentsFilterItem />
      <EmploymentFilterItem />
      <OfficeLocationsFilterItem />
      <PositionsFilterItem />
    </JobFilterContainer>
  );
};
